import { createContext } from 'react';
import LoginStore from './LoginStore';
import AdminLoginStore from './AdminLoginStore';
import MessageStore from './MessageStore';
import EmailStore from './EmailStore';

class AppStore {
  loginStore: LoginStore;
  adminLoginStore: AdminLoginStore;
  messageStore: MessageStore;
  emailStore: EmailStore;
  constructor() {
    this.loginStore = new LoginStore();
    this.adminLoginStore = new AdminLoginStore();
    this.messageStore = new MessageStore();
    this.emailStore = new EmailStore();
  }
}

export const AppContext = createContext(new AppStore());
